import React from 'react';
import {Link} from "react-router-dom";
import useProspectQuotesTabs
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectQuotesTabs/hooks/useProspectQuotesTabs";

export default function ProspectQuotesTabs() {
    const {parent = null, children = []} = useProspectQuotesTabs();

    return (
        <div className="prospect-tab__prospect__header__tabs">
            {parent && (
                <div className={`prospect-tab__prospect__header__tabs__tab ${parent.isCurrent ? 'active' : ''}`}>
                    {!parent.isCurrent
                        ? (
                            <Link to={parent.url}>
                                <span>{parent.label}</span>
                            </Link>
                        )
                        : <span>{parent.label}</span>
                    }
                </div>
            )}
            {children?.length > 0 && children.map((child, index) => (
                    <div key={index} className={`prospect-tab__prospect__header__tabs__tab ${child.isCurrent ? 'active' : ''}`}>
                        <Link to={child.url}>
                            <span>{child.label}</span>
                        </Link>
                    </div>
                )
            )}
        </div>
    )
}
